import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { WifiOff, CloudUpload } from "lucide-react";
import { useOnlineStatus } from "@/hooks/use-online-status";
import { subscribeCrmSyncPendingCount } from "@/lib/crm-sync-outbox";
import { subscribeImageUploadOutboxPendingCount } from "@/lib/image-upload-outbox";
import { getOfflineSyncRequireReview } from "@/lib/offline-sync-settings";
import { cn } from "@/lib/utils";

export function OfflineConnectivityBanner() {
  const { t } = useTranslation();
  const online = useOnlineStatus();
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    let imgCount = 0;
    let crmCount = 0;
    const update = () => setPendingCount(imgCount + crmCount);
    const unsub1 = subscribeImageUploadOutboxPendingCount((n) => { imgCount = n; update(); });
    const unsub2 = subscribeCrmSyncPendingCount((n) => { crmCount = n; update(); });
    return () => { unsub1(); unsub2(); };
  }, []);

  const showPendingBanner = online && pendingCount > 0 && getOfflineSyncRequireReview();

  if (!online) {
    return (
      <div
        role="status"
        className={cn(
          "w-full shrink-0 border-b border-amber-500/40 bg-amber-500/15 px-3 py-2 text-center text-sm text-amber-950 dark:text-amber-100",
        )}
      >
        <span className="inline-flex items-center justify-center gap-2">
          <WifiOff className="h-4 w-4 shrink-0 opacity-90" aria-hidden />
          <span>{t("connectivity.offlineBanner")}</span>
        </span>
      </div>
    );
  }

  if (showPendingBanner) {
    return (
      <div
        role="status"
        className={cn(
          "w-full shrink-0 border-b border-blue-500/40 bg-blue-500/10 px-3 py-2 text-center text-sm text-blue-950 dark:text-blue-100",
        )}
      >
        <span className="inline-flex items-center justify-center gap-2">
          <CloudUpload className="h-4 w-4 shrink-0 opacity-90" aria-hidden />
          <span>{t("connectivity.pendingReview", { count: pendingCount })}</span>
        </span>
      </div>
    );
  }

  return null;
}
